/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_M_Exp_DescInputs */

const es_nav_m_exp_desc = /** @type {(inputs: Nav_M_Exp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte la salida y el gasto`)
};

const gl_nav_m_exp_desc = /** @type {(inputs: Nav_M_Exp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte a saída e o gasto`)
};

const en_nav_m_exp_desc = /** @type {(inputs: Nav_M_Exp_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share the trip and the cost`)
};

/**
* | output |
* | --- |
* | "Share the trip and the cost" |
*
* @param {Nav_M_Exp_DescInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_m_exp_desc = /** @type {((inputs?: Nav_M_Exp_DescInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_M_Exp_DescInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_m_exp_desc(inputs)
	if (locale === "en") return en_nav_m_exp_desc(inputs)
	return es_nav_m_exp_desc(inputs)
});